export const NOTIFICATION_MESSAGES = {
  WatchMeActivate: 'Watch Me Requested',
  WatchMeCancel: 'Watch Me Canceled',
  Panic: 'Panic Alert',
  Holster: 'Weapon Drawn',
  CewArc: 'TASER Weapon Arced',
  CewArm: 'TASER Weapon Armed',
  CewTrigger: 'TASER Weapon Trigger Pulled',
  CewSwitchEnergize: 'TASER Weapon Energized due to Switch',
  CewTriggerEnergize: 'TASER Weapon Energized due to Trigger',
  CewRaised: 'TASER Weapon Raised while Armed',
  CewUnholstered: 'TASER Weapon Unholstered',
  CewWarning: 'TASER Weapon Warning Alerted',
  Gunshot: 'Gunshot',
  VehicleAcceleration: 'Vehicle Impact',
  AsuWeaponRack: 'Weapon Rack',
  AsuWeaponRack1: 'Weapon Rack',
  AsuWeaponRack2: 'Weapon Rack',
  AsuLightbar: 'Light Bar',
  AsuSiren: 'Siren',
  VehicleVelocity: 'Vehicle Speed Exceeded 95 MPH',
  AsuLightbarCode1: 'Light Bar Code 1',
  AsuLightbarCode2: 'Light Bar Code 2',
  AsuLightbarCode3: 'Light Bar Code 3',
  AsuRearDoorDriver: 'Rear Door Driver Side',
  AsuRearDoorPassenger: 'Rear Door Passenger Side',
  Baton: 'Baton Drawn',
  PepperSpray: 'Pepper Spray Drawn',
  Handcuff: 'Handcuff Drawn',
} as const;

/**
 * State-based notification categories that should persist on device markers
 * regardless of their age (not subject to the 15-minute expiration).
 * These represent ongoing device states rather than momentary events.
 */
export const STATE_BASED_NOTIFICATION_CATEGORIES = [
  'WatchMeActivate',
  'Panic',
] as const;

export type StateBasedNotificationCategory = typeof STATE_BASED_NOTIFICATION_CATEGORIES[number];
